import { Injectable, Inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';
import { EnvironmentInstanceToken, PaceEnvironment } from '@evorait/pace-core';
import { Observable, mergeMap, catchError, throwError, switchMap } from 'rxjs';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

@Injectable()
export class PaceMsalXIdTokenInterceptor implements HttpInterceptor {
    public constructor(
        private readonly msalService: MsalService,
        @Inject(EnvironmentInstanceToken) private readonly environment: PaceEnvironment,
    ) {}

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const btpApimScope = this.environment.btpApimScope ?? '';

        if (!navigator.onLine) {
            return next.handle(req);
        }

        return this.msalService.acquireTokenSilent({ scopes: [btpApimScope] }).pipe(
            catchError((error) => {
                if (error instanceof InteractionRequiredAuthError) {
                    return this.msalService
                        .acquireTokenRedirect({ scopes: [btpApimScope] })
                        .pipe(switchMap(() => throwError(() => error)));
                } else {
                    return throwError(() => error);
                }
            }),
            mergeMap((account) => {
                if (account) {
                    const cloned = req.clone({
                        setHeaders: {
                            'x-id-token': `Bearer ${account.accessToken}`,
                        },
                    });
                    return next.handle(cloned);
                }
                return next.handle(req);
            }),
        );
    }
}
